(() => {
  function initHeader(root = document) {
    const setHeaderMenuOpen = (header, open) => {
      if (!header) return;
      header.classList.toggle('is-open', open);
      document.body.classList.toggle('nb-mobile-menu-open', open);
      header.querySelector('[data-nb-menu-toggle]')?.setAttribute('aria-expanded', String(open));
      if (open) header.querySelector('[data-nb-menu-close]')?.focus();
    };

    root.querySelectorAll('[data-nb-menu-toggle]').forEach((toggle) => {
      if (toggle.dataset.bound === 'true') return;
      toggle.dataset.bound = 'true';
      toggle.addEventListener('click', () => {
        const header = toggle.closest('.nb-header');
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        setHeaderMenuOpen(header, !expanded);
      });
    });

    root.querySelectorAll('[data-nb-menu-close]').forEach((close) => {
      if (close.dataset.bound === 'true') return;
      close.dataset.bound = 'true';
      close.addEventListener('click', () => setHeaderMenuOpen(close.closest('.nb-header'), false));
    });

    root.querySelectorAll('.nb-header__menu a').forEach((link) => {
      if (link.dataset.headerLinkBound === 'true') return;
      link.dataset.headerLinkBound = 'true';
      link.addEventListener('click', () => setHeaderMenuOpen(link.closest('.nb-header'), false));
    });

    if (document.documentElement.dataset.nbHeaderEscapeBound !== 'true') {
      document.documentElement.dataset.nbHeaderEscapeBound = 'true';
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('.nb-header.is-open').forEach((header) => setHeaderMenuOpen(header, false));
      });
    }
  }

  function setSearchModalOpen(modal, open, trigger = null) {
    if (!modal) return;
    modal.classList.toggle('is-open', open);
    modal.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('nb-search-modal-open', open);

    const modalId = modal.id;
    document.querySelectorAll(`[data-search-modal-open][aria-controls="${modalId}"]`).forEach((button) => {
      button.setAttribute('aria-expanded', String(open));
    });

    if (open) {
      modal._returnFocus = trigger || document.activeElement;
      const header = modal.closest('.nb-header');
      header?.classList.remove('is-open');
      document.body.classList.remove('nb-mobile-menu-open');
      window.requestAnimationFrame(() => modal.querySelector('[data-quick-search-input]')?.focus());
    } else {
      modal._abortController?.abort();
      if (modal._returnFocus instanceof HTMLElement) modal._returnFocus.focus();
    }
  }

  function quickSearchImage(item, type) {
    let source;
    if (type === 'products') {
      source = typeof item.featured_image === 'string' ? item.featured_image : item.featured_image?.url;
    } else {
      source = typeof item.image === 'string' ? item.image : item.image?.url;
    }
    if (!source) return '';
    const imageUrl = new URL(source, window.location.origin);
    imageUrl.searchParams.set('width', '160');
    return imageUrl.href;
  }

  function createQuickSearchItem(item, type) {
    const link = document.createElement('a');
    link.className = 'nb-quick-search-item';
    link.href = item.url;

    const imageUrl = quickSearchImage(item, type);
    if (imageUrl) {
      const image = document.createElement('img');
      image.className = 'nb-quick-search-item__image';
      image.src = imageUrl;
      image.alt = item.featured_image?.alt || item.image?.alt || '';
      image.loading = 'lazy';
      link.append(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'nb-quick-search-item__placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.innerHTML = '<svg viewBox="0 0 24 24"><path d="M4 5h16v14H4z"></path><path d="m5 16 5-5 4 4 2-2 3 3"></path></svg>';
      link.append(placeholder);
    }

    const title = document.createElement('span');
    title.className = 'nb-quick-search-item__title';
    title.textContent = item.title;
    link.append(title);

    const arrow = document.createElement('span');
    arrow.className = 'nb-quick-search-item__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '›';
    link.append(arrow);
    return link;
  }

  function renderQuickSearch(modal, results, query) {
    const container = modal.querySelector('[data-quick-search-results]');
    const status = modal.querySelector('[data-quick-search-status]');
    const allLink = modal.querySelector('[data-quick-search-all]');
    const groups = [
      ['products', modal.dataset.productsLabel],
      ['articles', modal.dataset.articlesLabel],
      ['pages', modal.dataset.pagesLabel]
    ];
    const total = groups.reduce((count, [type]) => count + (results[type]?.length || 0), 0);
    container.replaceChildren();

    if (total === 0) {
      const message = document.createElement('p');
      message.className = 'nb-search-modal__message';
      message.textContent = modal.dataset.noResults;
      container.append(message);
      status.textContent = modal.dataset.noResults;
      allLink.hidden = true;
      return;
    }

    groups.forEach(([type, label]) => {
      const items = results[type] || [];
      if (items.length === 0) return;
      const group = document.createElement('section');
      group.className = 'nb-quick-search-group';
      const heading = document.createElement('h3');
      heading.textContent = label;
      const list = document.createElement('div');
      list.className = 'nb-quick-search-list';
      items.forEach((item) => list.append(createQuickSearchItem(item, type)));
      group.append(heading, list);
      container.append(group);
    });

    status.textContent = `${total} resultados`;
    const searchUrl = new URL(allLink.getAttribute('href'), window.location.origin);
    searchUrl.searchParams.set('q', query);
    searchUrl.searchParams.set('type', 'product,article,page');
    allLink.href = `${searchUrl.pathname}${searchUrl.search}`;
    allLink.hidden = false;
  }

  function initQuickSearch(root = document) {
    root.querySelectorAll('[data-search-modal-open]').forEach((trigger) => {
      if (trigger.dataset.searchBound === 'true') return;
      trigger.dataset.searchBound = 'true';
      trigger.addEventListener('click', () => {
        const modal = document.getElementById(trigger.getAttribute('aria-controls'));
        setSearchModalOpen(modal, true, trigger);
      });
    });

    root.querySelectorAll('[data-search-modal]').forEach((modal) => {
      if (modal.dataset.bound === 'true') return;
      modal.dataset.bound = 'true';
      const input = modal.querySelector('[data-quick-search-input]');
      const results = modal.querySelector('[data-quick-search-results]');
      const status = modal.querySelector('[data-quick-search-status]');
      const allLink = modal.querySelector('[data-quick-search-all]');
      let debounceTimer;

      modal.querySelectorAll('[data-search-modal-close]').forEach((button) => {
        button.addEventListener('click', () => setSearchModalOpen(modal, false));
      });

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          setSearchModalOpen(modal, false);
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [...modal.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]:not([hidden])')];
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      input.addEventListener('input', () => {
        window.clearTimeout(debounceTimer);
        modal._abortController?.abort();
        const query = input.value.trim();

        if (query.length < 2) {
          results.replaceChildren();
          status.textContent = '';
          allLink.hidden = true;
          modal.removeAttribute('aria-busy');
          return;
        }

        debounceTimer = window.setTimeout(() => {
          const controller = new AbortController();
          modal._abortController = controller;
          const url = new URL(modal.dataset.predictiveUrl, window.location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product,article,page');
          url.searchParams.set('resources[limit]', '6');
          url.searchParams.set('resources[options][unavailable_products]', 'last');
          modal.setAttribute('aria-busy', 'true');

          fetch(url, { headers: { Accept: 'application/json' }, signal: controller.signal })
            .then((response) => {
              if (!response.ok) throw new Error('Search request failed');
              return response.json();
            })
            .then((data) => renderQuickSearch(modal, data.resources?.results || {}, query))
            .catch((error) => {
              if (error.name === 'AbortError') return;
              results.replaceChildren();
              const message = document.createElement('p');
              message.className = 'nb-search-modal__message';
              message.textContent = modal.dataset.searchError;
              results.append(message);
              status.textContent = modal.dataset.searchError;
              allLink.hidden = true;
            })
            .finally(() => {
              if (modal._abortController === controller) modal.removeAttribute('aria-busy');
            });
        }, 250);
      });
    });
  }

  function setGalleryProductDialogOpen(dialog, open, trigger = null) {
    if (!dialog) return;
    if (open) {
      dialog._returnFocus = trigger || document.activeElement;
      if (!dialog.open) dialog.showModal();
      document.body.classList.add('nb-gallery-modal-open');
      dialog.querySelector('[data-gallery-product-close]')?.focus();
    } else if (dialog.open) {
      dialog.close();
    }
  }

  function initGalleryProductModals(root = document) {
    root.querySelectorAll('[data-gallery-product-open]').forEach((trigger) => {
      if (trigger.dataset.galleryBound === 'true') return;
      trigger.dataset.galleryBound = 'true';
      trigger.addEventListener('click', () => {
        const dialog = document.getElementById(trigger.dataset.galleryProductOpen);
        setGalleryProductDialogOpen(dialog, true, trigger);
      });
    });

    root.querySelectorAll('[data-gallery-product-dialog]').forEach((dialog) => {
      if (dialog.dataset.bound === 'true') return;
      dialog.dataset.bound = 'true';

      dialog.querySelector('[data-gallery-product-close]')?.addEventListener('click', () => {
        setGalleryProductDialogOpen(dialog, false);
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) setGalleryProductDialogOpen(dialog, false);
      });

      dialog.addEventListener('close', () => {
        document.body.classList.remove('nb-gallery-modal-open');
        if (dialog._returnFocus instanceof HTMLElement) dialog._returnFocus.focus();
      });

      const title = dialog.querySelector('[data-gallery-product-title]');
      const pickers = [...dialog.querySelectorAll('[data-gallery-product-picker]')];
      const showProduct = (picker) => {
        dialog.querySelectorAll('[data-gallery-product-media]').forEach((media) => {
          media.hidden = media.dataset.galleryProductMedia !== picker.dataset.productId;
        });
        if (title) title.textContent = picker.dataset.productTitle;
      };

      pickers.forEach((picker) => {
        picker.addEventListener('toggle', () => {
          if (!picker.open) return;
          pickers.forEach((otherPicker) => {
            if (otherPicker !== picker) otherPicker.open = false;
          });
          showProduct(picker);
        });
      });

      dialog.querySelectorAll('[data-gallery-variant-select]').forEach((select) => {
        const updateVariant = () => {
          const option = select.selectedOptions[0];
          const picker = select.closest('[data-gallery-product-picker]');
          const price = picker?.querySelector('[data-gallery-product-price]');
          const addButton = select.closest('form')?.querySelector('[name="add"]');
          if (price && option?.dataset.price) price.textContent = option.dataset.price;
          if (addButton) addButton.disabled = !select.value || option?.disabled;

          if (option?.dataset.image && picker) {
            const media = dialog.querySelector(`[data-gallery-product-media="${picker.dataset.productId}"]`);
            const image = media?.querySelector('.nb-gallery-product-modal__product-image');
            if (image) {
              image.src = option.dataset.image;
              image.removeAttribute('srcset');
              image.removeAttribute('sizes');
            }
          }
        };
        select.addEventListener('change', updateVariant);
        updateVariant();
      });
    });

    if (document.documentElement.dataset.galleryProductEventBound !== 'true') {
      document.documentElement.dataset.galleryProductEventBound = 'true';
      document.addEventListener('product:added', (event) => {
        const dialog = event.detail?.form?.closest('[data-gallery-product-dialog]');
        if (dialog) setGalleryProductDialogOpen(dialog, false);
      });
    }
  }

  function initQuantity(root = document) {
    root.querySelectorAll('[data-quantity-control]').forEach((control) => {
      if (control.dataset.bound === 'true') return;
      control.dataset.bound = 'true';
      const input = control.querySelector('input');
      const minus = control.querySelector('[data-quantity-action="minus"]');
      const plus = control.querySelector('[data-quantity-action="plus"]');
      if (!input || !minus || !plus) return;

      const getRules = () => ({
        min: Number(input.min || 1),
        max: input.max === '' ? Infinity : Number(input.max),
        step: Number(input.step || 1)
      });
      const normalize = (value) => {
        const { min, max, step } = getRules();
        const numericValue = Number.isFinite(Number(value)) ? Number(value) : min;
        const steppedValue = min + Math.round((numericValue - min) / step) * step;
        return Math.min(max, Math.max(min, steppedValue));
      };
      const updateState = () => {
        const { min, max, step } = getRules();
        const value = normalize(input.value);
        input.value = String(value);
        minus.disabled = value - step < min;
        plus.disabled = value + step > max;
      };

      control.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-quantity-action]');
        if (!button || button.disabled) return;
        const { step } = getRules();
        const current = normalize(input.value);
        input.value = String(normalize(button.dataset.quantityAction === 'plus' ? current + step : current - step));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      input.addEventListener('change', updateState);
      updateState();
    });
  }

  function initCollectionGrid(root = document) {
    root.querySelectorAll('[data-collection-grid]').forEach((grid) => {
      if (grid.dataset.bound === 'true') return;
      grid.dataset.bound = 'true';
      const scope = grid.closest('.nb-collection') || document;
      const viewButtons = scope.querySelectorAll('[data-grid-mode]');
      const limitButtons = scope.querySelectorAll('[data-products-limit]');
      const storageKey = 'nonbak-grid-columns';

      const applyColumns = (columns) => {
        const allowedColumns = [...viewButtons].map((button) => button.dataset.gridMode);
        if (!allowedColumns.includes(String(columns))) {
          columns = viewButtons[0]?.dataset.gridMode || 3;
        }
        grid.style.setProperty('--collection-columns', columns);
        viewButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.gridMode === String(columns)));
        localStorage.setItem(storageKey, String(columns));
      };

      const applyLimit = (limit) => {
        const cards = [...grid.querySelectorAll('.nb-product-card')];
        cards.forEach((card, index) => {
          card.hidden = index >= limit;
        });
        limitButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.productsLimit === String(limit)));
      };

      viewButtons.forEach((button) => {
        button.addEventListener('click', () => applyColumns(button.dataset.gridMode));
      });
      limitButtons.forEach((button) => {
        button.addEventListener('click', () => applyLimit(Number(button.dataset.productsLimit)));
      });

      const savedColumns = localStorage.getItem(storageKey);
      if (savedColumns) applyColumns(savedColumns);
    });
  }

  function setCollectionSidebarOpen(open, trigger = null) {
    document.body.classList.toggle('nb-collection-sidebar-open', open);
    document.querySelectorAll('[data-collection-sidebar-open]').forEach((button) => {
      button.setAttribute('aria-expanded', String(open));
    });
    if (open) {
      const sidebarId = trigger?.getAttribute('aria-controls');
      const sidebar = sidebarId ? document.getElementById(sidebarId) : document.querySelector('.nb-collection__sidebar');
      sidebar?.querySelector('[data-collection-sidebar-close]')?.focus();
    }
  }

  function initCollectionSidebar(root = document) {
    root.querySelectorAll('[data-collection-sidebar-open]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => setCollectionSidebarOpen(true, button));
    });

    root.querySelectorAll('[data-collection-sidebar-close]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => setCollectionSidebarOpen(false));
    });
  }

  function initPriceRanges(root = document) {
    root.querySelectorAll('[data-nb-price-range]').forEach((range) => {
      if (range.dataset.bound === 'true') return;
      range.dataset.bound = 'true';

      const minInput = range.querySelector('[data-nb-price-input="min"]');
      const maxInput = range.querySelector('[data-nb-price-input="max"]');
      const minField = range.querySelector('[data-nb-price-value="min"]');
      const maxField = range.querySelector('[data-nb-price-value="max"]');
      const minOutput = range.closest('form')?.querySelector('[data-nb-price-output="min"]');
      const maxOutput = range.closest('form')?.querySelector('[data-nb-price-output="max"]');
      const rangeMax = Number(range.dataset.rangeMax) || 0;
      if (!minInput || !maxInput || !minField || !maxField || rangeMax <= 0) return;

      const currency = range.dataset.currency;
      const formatter = currency
        ? new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency })
        : null;

      const sync = (source) => {
        let minValue = Number(minInput.value);
        let maxValue = Number(maxInput.value);

        if (source === minInput && minValue > maxValue) {
          minValue = maxValue;
          minInput.value = String(minValue);
        } else if (source === maxInput && maxValue < minValue) {
          maxValue = minValue;
          maxInput.value = String(maxValue);
        }

        minField.value = minValue > 0 ? String(minValue) : '';
        maxField.value = maxValue < rangeMax ? String(maxValue) : '';
        minField.disabled = false;
        maxField.disabled = false;
        range.style.setProperty('--price-range-start', `${(minValue / rangeMax) * 100}%`);
        range.style.setProperty('--price-range-end', `${(maxValue / rangeMax) * 100}%`);
        minInput.style.zIndex = minValue > rangeMax * 0.9 ? '4' : '2';

        if (formatter) {
          if (minOutput) minOutput.textContent = formatter.format(minValue);
          if (maxOutput) maxOutput.textContent = formatter.format(maxValue);
        }
      };

      minInput.addEventListener('input', () => sync(minInput));
      maxInput.addEventListener('input', () => sync(maxInput));
      sync();
    });
  }

  function setArticleSidebarOpen(open) {
    document.body.classList.toggle('nb-article-sidebar-open', open);
    document.querySelectorAll('[data-article-sidebar-open]').forEach((button) => {
      button.setAttribute('aria-expanded', String(open));
    });
    if (open) document.querySelector('.nb-article__sidebar')?.focus();
  }

  function initArticleSidebar(root = document) {
    root.querySelectorAll('[data-article-sidebar-open]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => setArticleSidebarOpen(true));
    });

    root.querySelectorAll('[data-article-sidebar-close]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => setArticleSidebarOpen(false));
    });
  }

  function getCartDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function setCartDrawerOpen(open) {
    const drawer = getCartDrawer();
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('nb-cart-drawer-open', open);
    if (open) drawer.querySelector('.nb-cart-drawer__panel')?.focus();
  }

  function initCartDrawer(root = document) {
    root.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
      if (trigger.dataset.bound === 'true') return;
      trigger.dataset.bound = 'true';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        setCartDrawerOpen(true);
      });
    });

    root.querySelectorAll('[data-cart-drawer-close]').forEach((trigger) => {
      if (trigger.dataset.bound === 'true') return;
      trigger.dataset.bound = 'true';
      trigger.addEventListener('click', () => setCartDrawerOpen(false));
    });

    initCartTerms(root);
  }

  var CART_TERMS_KEY = 'nb-cart-terms-accepted';

  function readCartTerms() {
    try {
      return sessionStorage.getItem(CART_TERMS_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function writeCartTerms(accepted) {
    try {
      sessionStorage.setItem(CART_TERMS_KEY, String(accepted));
    } catch (error) {
      /* modo privado: seguimos sin persistir */
    }
  }

  function initCartTerms(root = document) {
    const forms = root instanceof Element && root.matches('[data-cart-terms-form]')
      ? [root]
      : [...root.querySelectorAll('[data-cart-terms-form]')];

    forms.forEach((form) => {
      if (form.dataset.termsBound === 'true') return;
      form.dataset.termsBound = 'true';

      const checkbox = form.querySelector('[data-cart-terms-checkbox]');
      const error = form.querySelector('[data-cart-terms-error]');
      const guard = form.querySelector('[data-cart-terms-guard]');

      if (!checkbox) {
        form.classList.add('is-terms-accepted');
        return;
      }

      // El drawer se repinta entero al cambiar cantidades, así que la
      // aceptación se recuerda durante la sesión para no pedirla dos veces.
      checkbox.checked = readCartTerms();

      const sync = () => {
        form.classList.toggle('is-terms-accepted', checkbox.checked);
        if (checkbox.checked && error) error.hidden = true;
        writeCartTerms(checkbox.checked);
      };

      const reject = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (error) error.hidden = false;
        checkbox.focus();
      };

      checkbox.addEventListener('change', sync);
      form.addEventListener('submit', (event) => {
        if (!checkbox.checked) reject(event);
      });
      if (guard) guard.addEventListener('click', reject);

      sync();
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((count) => {
          if (count.dataset.cartCountStyle === 'number') {
            count.textContent = cart.item_count;
          } else {
            count.textContent = cart.item_count === 1 ? '1 artículo' : `${cart.item_count} artículos`;
          }
        });
        document.querySelectorAll('[data-cart-total]').forEach((total) => {
          const currency = total.dataset.currency || cart.currency;
          if (!currency) return;
          total.textContent = new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency',
            currency
          }).format(cart.total_price / 100);
        });
        return cart;
      })
      .catch(() => null);
  }

  function replaceCartDrawer(sectionHtml) {
    if (!sectionHtml) return;
    const current = getCartDrawer();
    if (!current) return;
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const next = doc.querySelector('[data-cart-drawer]');
    if (!next) return;
    current.replaceWith(next);
    initCartDrawer(next);
    initCartLines(next);
    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
  }

  function replaceCartPage(sectionHtml) {
    if (!sectionHtml) return;
    const current = document.querySelector('[data-cart-page]');
    if (!current) return;
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const next = doc.querySelector('[data-cart-page]');
    if (!next) return;
    current.replaceWith(next);
    initCartLines(next);
  }

  function showCartUpdateError(root, message) {
    root?.querySelector('.nb-cart-update-error')?.remove();
    const error = document.createElement('p');
    error.className = 'nb-cart-update-error';
    error.setAttribute('role', 'alert');
    error.textContent = message || 'No se ha podido actualizar el carrito.';
    (root?.querySelector('.nb-cart-drawer__header') || root)?.insertAdjacentElement('afterend', error);
  }

  function updateCartLine(lineKey, quantity, source) {
    const drawer = source.closest('[data-cart-drawer]');
    const cartPage = source.closest('[data-cart-page]');
    const busyRoots = [drawer, cartPage].filter(Boolean);
    busyRoots.forEach((root) => {
      root.setAttribute('aria-busy', 'true');
      root.querySelector('.nb-cart-update-error')?.remove();
    });

    return fetch('/cart/change.js?sections=cart-drawer,cart', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity })
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().catch(() => ({})).then((error) => {
            throw new Error(error.description || error.message || 'No se ha podido actualizar el carrito.');
          });
        }
        return response.json();
      })
      .then((cart) => {
        replaceCartDrawer(cart.sections && cart.sections['cart-drawer']);
        replaceCartPage(cart.sections && cart.sections.cart);
        return refreshCartCount();
      })
      .then(() => {
        if (drawer) setCartDrawerOpen(true);
      })
      .catch((error) => {
        busyRoots.forEach((root) => root.removeAttribute('aria-busy'));
        showCartUpdateError(drawer || cartPage, error.message);
      });
  }

  function initCartLines(root = document) {
    const cartRoots = root instanceof Element && root.matches('[data-cart-drawer], [data-cart-page]')
      ? [root]
      : [...root.querySelectorAll('[data-cart-drawer], [data-cart-page]')];

    cartRoots.forEach((cartRoot) => {
      if (cartRoot.dataset.linesBound === 'true') return;
      cartRoot.dataset.linesBound = 'true';

      cartRoot.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          event.preventDefault();
          updateCartLine(remove.dataset.cartLineKey, 0, remove);
          return;
        }

        const button = event.target.closest('[data-cart-quantity-action]');
        if (!button) return;
        const control = button.closest('[data-cart-quantity-control]');
        const input = control?.querySelector('[data-cart-quantity-input]');
        if (!control || !input) return;
        const current = Number(input.value || 0);
        const quantity = button.dataset.cartQuantityAction === 'plus' ? current + 1 : Math.max(0, current - 1);
        input.value = String(quantity);
        updateCartLine(control.dataset.cartLineKey, quantity, control);
      });

      cartRoot.addEventListener('change', (event) => {
        const input = event.target.closest('[data-cart-quantity-input]');
        if (!input) return;
        const control = input.closest('[data-cart-quantity-control]');
        const quantity = Math.max(0, Math.floor(Number(input.value) || 0));
        input.value = String(quantity);
        updateCartLine(control.dataset.cartLineKey, quantity, control);
      });
    });
  }

  function initProductForms(root = document) {
    root.querySelectorAll('form[data-product-form]').forEach((form) => {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const button = form.querySelector('[name="add"]');
        const originalText = button?.textContent;
        form.querySelector('.nb-cart-form-error')?.remove();
        if (button) {
          button.disabled = true;
          button.textContent = 'Añadiendo...';
        }

        fetch('/cart/add.js?sections=cart-drawer', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().catch(() => ({})).then((error) => {
                throw new Error(error.description || error.message || 'No se ha podido añadir al carrito.');
              });
            }
            return response.json();
          })
          .then((data) => {
            replaceCartDrawer(data.sections && data.sections['cart-drawer']);
            return refreshCartCount();
          })
          .then(() => {
            setCartDrawerOpen(true);
            document.dispatchEvent(new CustomEvent('product:added', { detail: { form } }));
          })
          .catch((error) => {
            const message = document.createElement('p');
            message.className = 'nb-cart-form-error';
            message.setAttribute('role', 'alert');
            message.textContent = error.message || 'No se ha podido añadir al carrito.';
            form.append(message);
          })
          .finally(() => {
            if (button) {
              button.disabled = false;
              button.textContent = originalText;
            }
          });
      });
    });
  }

  // PDP: the variant select starts empty so the general photos show; picking a
  // variant puts its image in the first gallery slot and enables the buttons.
  function initVariantMedia(root = document) {
    root.querySelectorAll('select[data-variant-select]').forEach((select) => {
      if (select.dataset.mediaBound === 'true') return;
      select.dataset.mediaBound = 'true';
      const form = select.closest('form');
      const section = select.closest('.nb-product');
      const main = section?.querySelector('.nb-product__image--main');
      const img = main?.querySelector('img');
      if (!form) return;
      const original = img && { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), href: main.getAttribute('href') };
      const srcset = (src) => [360, 540, 720, 1000, 1200].map((w) => `${src.replace(/width=\d+/, `width=${w}`)} ${w}w`).join(', ');

      const update = (scroll) => {
        const option = select.selectedOptions[0];
        if (!option || !option.value) return;
        form.classList.remove('is-unselected');
        const add = form.querySelector('[name="add"]');
        if (add) add.disabled = false;
        if (!img) return;
        const src = option.dataset.mediaSrc;
        img.setAttribute('src', src || original.src);
        if (src) img.setAttribute('srcset', srcset(src)); else if (original.srcset) img.setAttribute('srcset', original.srcset);
        if (main.hasAttribute('href')) main.setAttribute('href', option.dataset.mediaZoom || original.href);
        if (!scroll) return;
        const media = main.parentElement;
        if (media.scrollWidth > media.clientWidth && media.scrollLeft > 0) media.scrollTo({ left: 0, behavior: 'smooth' });
        else if (main.getBoundingClientRect().top < 0) main.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      select.addEventListener('change', () => update(true));
      if (select.value) update(false);
    });
  }

  function initSlideshows(root = document) {
    root.querySelectorAll('[data-nb-slideshow]').forEach((slideshow) => {
      if (slideshow.dataset.bound === 'true') return;
      slideshow.dataset.bound = 'true';
      const slides = [...slideshow.querySelectorAll('[data-nb-slide]')];
      const dots = [...slideshow.querySelectorAll('[data-nb-slideshow-dot]')];
      if (slides.length < 2) return;
      let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer;

      const showSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-selected', String(dotIndex === activeIndex)));
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (slideshow.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(() => showSlide(activeIndex + 1), Number(slideshow.dataset.interval) || 6000);
      };

      slideshow.querySelector('[data-nb-slideshow-prev]')?.addEventListener('click', () => { showSlide(activeIndex - 1); start(); });
      slideshow.querySelector('[data-nb-slideshow-next]')?.addEventListener('click', () => { showSlide(activeIndex + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { showSlide(Number(dot.dataset.nbSlideshowDot)); start(); }));
      slideshow.addEventListener('mouseenter', stop);
      slideshow.addEventListener('mouseleave', start);
      slideshow.addEventListener('focusin', stop);
      slideshow.addEventListener('focusout', start);
      slideshow.addEventListener('shopify:block:select', (event) => {
        const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) showSlide(index);
        stop();
      });
      showSlide(activeIndex);
      start();
    });
  }

  function initCountdowns(root = document) {
    root.querySelectorAll('[data-nb-countdown]').forEach((countdown) => {
      if (countdown.dataset.bound === 'true') return;
      countdown.dataset.bound = 'true';
      const target = Date.parse(countdown.dataset.target);
      if (!Number.isFinite(target)) return;
      const timer = countdown.querySelector('[data-nb-countdown-timer]');
      const end = countdown.querySelector('[data-nb-countdown-end]');
      const parts = Object.fromEntries([...countdown.querySelectorAll('[data-countdown-part]')].map((part) => [part.dataset.countdownPart, part]));
      let interval;

      const update = () => {
        const remaining = Math.max(0, target - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60
        };
        Object.entries(values).forEach(([name, value]) => {
          if (parts[name]) parts[name].textContent = String(value).padStart(2, '0');
        });
        if (remaining > 0) return;
        window.clearInterval(interval);
        if (timer) timer.hidden = true;
        if (end) end.hidden = false;
      };

      update();
      interval = window.setInterval(update, 1000);
    });
  }

  function initBeforeAfter(root = document) {
    root.querySelectorAll('[data-before-after]').forEach((section) => {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';
      const range = section.querySelector('[data-before-after-range]');
      const frame = range?.closest('.nb-before-after__frame');
      if (!range || !frame) return;
      const update = () => frame.style.setProperty('--nb-before-after-position', `${range.value}%`);
      range.addEventListener('input', update);
      update();
    });
  }

  function initProductYoutube(root = document) {
    root.querySelectorAll('[data-nb-youtube]').forEach((tile) => {
      if (tile.dataset.bound === 'true') return;
      tile.dataset.bound = 'true';

      const trigger = tile.querySelector('.nb-product__youtube-trigger, [data-nb-youtube-trigger]');
      if (!trigger) return;

      // Tiles ask for maxresdefault: it is native 16:9 with no letterboxing,
      // unlike hqdefault, which is a 4:3 canvas with black bars baked into the
      // JPG. It does not exist for every video though, and YouTube answers a
      // missing one with 200 and a 120x90 grey placeholder, so fall back to
      // hqdefault when the image comes back that small.
      const thumbnail = tile.querySelector('img');
      if (thumbnail) {
        const fallback = () => {
          if (thumbnail.naturalWidth > 0 && thumbnail.naturalWidth <= 120) {
            thumbnail.src = `https://i.ytimg.com/vi/${tile.dataset.nbYoutube}/hqdefault.jpg`;
          }
        };
        if (thumbnail.complete) fallback();
        else thumbnail.addEventListener('load', fallback, { once: true });
      }

      trigger.addEventListener('click', () => {
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${tile.dataset.nbYoutube}?autoplay=1&rel=0`;
        iframe.title = trigger.getAttribute('aria-label') || 'YouTube';
        iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        tile.replaceChildren(iframe);
      });
    });
  }

  // Scroll-snap track plus dots. Used by the icon row and the product gallery.
  function initDotSliders(root = document) {
    root.querySelectorAll('[data-nb-slider]').forEach((track) => {
      const dots = document.querySelector(`[data-nb-slider-dots="${track.dataset.nbSlider}"]`);
      if (!dots || track.dataset.bound === 'true') return;
      track.dataset.bound = 'true';

      const buttons = Array.from(dots.children);
      // hasAttribute, no dataset: `data-nb-slider-skip` no lleva valor, así que
      // dataset devuelve "" y el filtro dejaba pasar la etiqueta de oferta.
      // Con ella dentro, cada punto marcaba la diapositiva siguiente.
      const slides = Array.from(track.children).filter((el) => !el.hasAttribute('data-nb-slider-skip'));

      const sync = () => {
        // Whichever slide's centre sits closest to the track's centre is active.
        const middle = track.scrollLeft + track.clientWidth / 2;
        let active = 0;
        let best = Infinity;
        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - middle);
          if (distance < best) {
            best = distance;
            active = index;
          }
        });
        buttons.forEach((button, index) => {
          button.setAttribute('aria-selected', String(index === active));
        });
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          const slide = slides[index];
          if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', () => {
        window.clearTimeout(track.dataset.timer);
        track.dataset.timer = window.setTimeout(sync, 60);
      });
      sync();
    });
  }

  function initUgcVideos(root = document) {
    root.querySelectorAll('[data-nb-ugc]').forEach((section) => {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';

      const track = section.querySelector('[data-nb-ugc-track]');
      const videos = [...section.querySelectorAll('[data-nb-ugc-video]')];

      section.querySelectorAll('[data-nb-ugc-play]').forEach((button) => {
        button.addEventListener('click', () => {
          const media = button.closest('[data-nb-ugc-media]');
          const video = media?.querySelector('[data-nb-ugc-video]');
          if (!video) return;

          videos.forEach((other) => {
            if (other === video) return;
            other.pause();
            other.closest('[data-nb-ugc-media]')?.classList.remove('is-playing');
          });

          video.setAttribute('controls', '');
          media.classList.add('is-playing');
          video.play();
        });
      });

      if (!track) return;

      const prev = section.querySelector('[data-nb-ugc-prev]');
      const next = section.querySelector('[data-nb-ugc-next]');

      const step = () => {
        const card = track.querySelector('[data-nb-ugc-card]');
        if (!card) return track.clientWidth;
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return card.offsetWidth + gap;
      };

      const syncArrows = () => {
        const maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= maxScroll;
      };

      const scrollBy = (direction) => {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        track.scrollBy({ left: direction * step(), behavior });
      };

      prev?.addEventListener('click', () => scrollBy(-1));
      next?.addEventListener('click', () => scrollBy(1));
      track.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);

      section.addEventListener('shopify:block:select', (event) => {
        const card = track.querySelector(`[data-block-id="${event.detail.blockId}"]`);
        if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });

      syncArrows();
    });
  }

  function initProductZoom(root = document) {
    root.querySelectorAll('[data-product-zoom-dialog]').forEach((dialog) => {
      if (dialog.dataset.bound === 'true') return;
      dialog.dataset.bound = 'true';
      const image = dialog.querySelector('[data-product-zoom-image]');
      const section = dialog.closest('.nb-product');

      section?.querySelectorAll('[data-product-zoom-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          dialog._returnFocus = trigger;
          if (image) {
            image.src = trigger.href;
            image.alt = trigger.querySelector('img')?.alt || '';
          }
          dialog.showModal();
          dialog.querySelector('[data-product-zoom-close]')?.focus();
        });
      });

      dialog.querySelector('[data-product-zoom-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (dialog._returnFocus instanceof HTMLElement) dialog._returnFocus.focus();
      });
    });
  }

  class NonbakDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      if (this.dataset.deliveryReady === 'true') return;
      this.dataset.deliveryReady = 'true';
      this.updateEstimate();
      this.deliveryTimer = window.setInterval(() => this.updateEstimate(), 60000);
    }

    disconnectedCallback() {
      window.clearInterval(this.deliveryTimer);
      delete this.dataset.deliveryReady;
    }

    getCurrentParts() {
      const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: 'h23'
      };
      const timeZone = this.dataset.timeZone?.trim();
      if (timeZone) options.timeZone = timeZone;

      let formatter;
      try {
        formatter = new Intl.DateTimeFormat('en-CA', options);
      } catch {
        delete options.timeZone;
        formatter = new Intl.DateTimeFormat('en-CA', options);
      }

      return Object.fromEntries(
        formatter
          .formatToParts(new Date())
          .filter((part) => part.type !== 'literal')
          .map((part) => [part.type, Number.parseInt(part.value, 10)])
      );
    }

    addDeliveryDays(date, days, businessDaysOnly) {
      const result = new Date(date);
      let elapsed = 0;

      while (elapsed < days) {
        result.setUTCDate(result.getUTCDate() + 1);
        const weekday = result.getUTCDay();
        if (!businessDaysOnly || (weekday !== 0 && weekday !== 6)) elapsed += 1;
      }

      if (businessDaysOnly && days === 0) {
        while (result.getUTCDay() === 0 || result.getUTCDay() === 6) {
          result.setUTCDate(result.getUTCDate() + 1);
        }
      }

      return result;
    }

    formatDeliveryDate(date) {
      const locale = this.dataset.dateLocale?.trim() || document.documentElement.lang || 'es-ES';
      let formatter;
      try {
        formatter = new Intl.DateTimeFormat(locale, {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          timeZone: 'UTC'
        });
      } catch {
        formatter = new Intl.DateTimeFormat('es-ES', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          timeZone: 'UTC'
        });
      }

      return formatter.format(date);
    }

    updateEstimate() {
      const output = this.querySelector('[data-delivery-window]');
      if (!output) return;

      const current = this.getCurrentParts();
      const firstSetting = Math.max(0, Number.parseInt(this.dataset.minimumDays, 10) || 0);
      const lastSetting = Math.max(0, Number.parseInt(this.dataset.maximumDays, 10) || 0);
      const minimumDays = Math.min(firstSetting, lastSetting);
      const maximumDays = Math.max(firstSetting, lastSetting);
      const cutoffHour = Math.min(23, Math.max(0, Number.parseInt(this.dataset.cutoffHour, 10) || 0));
      const afterCutoff = this.dataset.cutoffEnabled === 'true' && current.hour >= cutoffHour;
      const cutoffShift = afterCutoff ? 1 : 0;
      const businessDaysOnly = this.dataset.businessDays === 'true';
      const today = new Date(Date.UTC(current.year, current.month - 1, current.day, 12));
      const firstDate = this.addDeliveryDays(today, minimumDays + cutoffShift, businessDaysOnly);
      const lastDate = this.addDeliveryDays(today, maximumDays + cutoffShift, businessDaysOnly);
      const firstLabel = this.formatDeliveryDate(firstDate);
      const lastLabel = this.formatDeliveryDate(lastDate);
      const dateWindow = firstDate.getTime() === lastDate.getTime()
        ? `${this.dataset.onLabel} ${firstLabel}`
        : `${this.dataset.betweenLabel} ${firstLabel} ${this.dataset.andLabel} ${lastLabel}`;

      output.textContent = [this.dataset.prefix, dateWindow].filter(Boolean).join(' ');

      const cutoffTime = this.querySelector('[data-delivery-cutoff-time]');
      if (cutoffTime) {
        const formattedHour = `${String(cutoffHour).padStart(2, '0')}:00`;
        cutoffTime.dateTime = formattedHour;
        cutoffTime.textContent = formattedHour;
      }

      const afterCutoffNote = this.querySelector('[data-delivery-after-cutoff]');
      if (afterCutoffNote) afterCutoffNote.hidden = !afterCutoff;
    }
  }

  function initLocaleSwitcher(root = document) {
    root.querySelectorAll('[data-nb-locale]').forEach((box) => {
      if (box.dataset.bound === 'true') return;
      box.dataset.bound = 'true';

      // A <details> stays open until its own summary is clicked again; a
      // language picker should close as soon as the shopper looks elsewhere.
      document.addEventListener('click', (event) => {
        if (box.open && !box.contains(event.target)) box.open = false;
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !box.open) return;
        box.open = false;
        box.querySelector('summary')?.focus();
      });
    });
  }

  function initKlaviyoFallback(root = document) {
    root.querySelectorAll('[data-nb-klaviyo]').forEach((box) => {
      if (box.dataset.bound === 'true') return;
      box.dataset.bound = 'true';

      const fallback = box.parentElement?.querySelector('.nb-footer__newsletter--fallback');
      if (!fallback) return;

      // El script de Klaviyo rellena el div cuando llega. Si lo bloquea una
      // extensión, Safari o el consentimiento de cookies, el hueco se queda
      // vacío: pasados 3,5 s se enseña el formulario del tema en su lugar.
      const decide = () => {
        // El div de Klaviyo se deja en su sitio aunque esté vacío: ocultarlo
        // podría impedirle medirse si el script llega tarde. Vacío ocupa 0px.
        const pintado = box.children.length > 0;
        fallback.classList.toggle('is-visible', !pintado);
      };

      const observer = new MutationObserver(decide);
      observer.observe(box, { childList: true });
      window.setTimeout(decide, 3500);
    });
  }

  function initAll(root = document) {
    initHeader(root);
    initKlaviyoFallback(root);
    initLocaleSwitcher(root);
    initQuickSearch(root);
    initGalleryProductModals(root);
    initQuantity(root);
    initCollectionGrid(root);
    initCollectionSidebar(root);
    initPriceRanges(root);
    initArticleSidebar(root);
    initCartDrawer(root);
    initCartLines(root);
    initProductForms(root);
    initVariantMedia(root);
    initSlideshows(root);
    initCountdowns(root);
    initBeforeAfter(root);
    initProductZoom(root);
    initProductYoutube(root);
    initDotSliders(root);
    initUgcVideos(root);
  }

  if (!customElements.get('nonbak-delivery-estimate')) {
    customElements.define('nonbak-delivery-estimate', NonbakDeliveryEstimate);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setCartDrawerOpen(false);
      setCollectionSidebarOpen(false);
      setArticleSidebarOpen(false);
    }
  });
})();
